import { Box, Button, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";
import BackButton from "components/button/ExportButton";
import ButtonComponent from "components/button/ButtonComponent";
import WheelCodeSearchTable from "../components/WheelCodeSearchTable";
import useWheelCode from "../hooks/useWheelCode";
import { CombinationType } from "../types/wheel-code";

const styles = {
  title: {
    fontSize: { sm: "18px", md: "20px", xl: "25px" },
    fontWeight: "medium",
    color: "var(--gray-700)",
    mb: 2.5,
  },
  sectionTitle: {
    fontSize: { xs: 20, md: 28, xl: 34 },
    mt: 4,
    mb: { xs: 2, md: 3 },
  },
  textButton: {
    fontSize: { xs: "16px", md: "20px", xl: "25px" },
  },
  button: {
    width: "287px",
    marginX: "auto",
    mt: { xs: 2, md: 3, xl: 4 },
  },
  tableBox: {
    overflowX: "auto",
    width: { xs: "100%", lg: "auto" },
    borderBottom: "1px solid var(--gray-250)",
    pb: 5,
  },
};

/**
 * Component representing the WheelCode page.
 * This page allows users to search for car rims by product code
 * and navigate to other parts of the application.
 */
export default function WheelCode() {
  const navigate = useNavigate();
  const {
    handleWheelSearch,
    handleTireSearch,
    removeTireItem,
    removeWheelItem,
    handleBackToQuoteList,
    onHandleNavigate,
  } = useWheelCode();

  return (
    <>
      <Box sx={{ px: { xs: 2, md: 2.5, lg: 5 }, pt: { xs: 2, md: 2.5, lg: 3 } }}>
        <Button onClick={() => navigate(-1)} variant="custom-outlined">
          <Box>＜ 戻る</Box>
        </Button>
      </Box>
      <Box
        sx={{
          p: { xs: 2, md: 2.5, lg: 5 },
          mb: 5,
          display: "flex",
          flexWrap: { sm: "wrap", xl: "nowrap" },
        }}
      >
      <Box>
        <Typography sx={{ ...styles.title }}>新規見積</Typography>
        <BackButton
          sx={{ ...styles.textButton }}
          label="見積一覧"
          onClick={handleBackToQuoteList}
        />
      </Box>
      <Box sx={{ mx: "auto", width: { xs: "100%", lg: "auto" } }}>
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            width: "100%",
          }}
        >
          <Typography variant="h4" sx={styles.sectionTitle}>
            商品コードの組合せ（ホイール1種類＋タイヤ5種類まで検索したい場合）
          </Typography>
          <Box sx={styles.tableBox}>
            <WheelCodeSearchTable
              onSearchWheel={(productCode) =>
                handleWheelSearch(productCode, CombinationType.WheelWithTires)
              }
              onSearchTire={(productCode) =>
                handleTireSearch(productCode, CombinationType.WheelWithTires)
              }
              onRemoveWheel={(productCode) =>
                removeWheelItem(productCode, CombinationType.WheelWithTires)
              }
              onRemoveTire={(productCode) =>
                removeTireItem(productCode, CombinationType.WheelWithTires)
              }
              wheelRowCount={1}
              tireRowCount={5}
            />
          </Box>
          <ButtonComponent
            theme="dark"
            onClick={() => onHandleNavigate(CombinationType.WheelWithTires)}
            label="商品選択へ進む"
            sx={{ ...styles.button, ...styles.textButton }}
          />

          <Typography
            variant="h4"
            sx={{
              ...styles.sectionTitle,
              mt: { xs: 6, lg: 12 },
            }}
          >
            商品コードの組合せ（タイヤ1種類＋ホイール4種類までを検索したい場合）
          </Typography>
          <Box sx={styles.tableBox}>
            <WheelCodeSearchTable
              onSearchWheel={(productCode) =>
                handleWheelSearch(productCode, CombinationType.TireWithWheels)
              }
              onSearchTire={(productCode) =>
                handleTireSearch(productCode, CombinationType.TireWithWheels)
              }
              onRemoveWheel={(productCode) =>
                removeWheelItem(productCode, CombinationType.TireWithWheels)
              }
              onRemoveTire={(productCode) =>
                removeTireItem(productCode, CombinationType.TireWithWheels)
              }
              wheelRowCount={4}
              tireRowCount={1}
            />
          </Box>
          <ButtonComponent
            theme="dark"
            onClick={() => onHandleNavigate(CombinationType.TireWithWheels)}
            label="商品選択へ進む"
            sx={{ ...styles.button, ...styles.textButton }}
          />
        </Box>
      </Box>
    </Box>
    </>
  );
}
